var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273.856,
    height: 237.404,
    viewBox: "0 0 273.856 237.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #99e7ff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #8ad0e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #b3edff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond-ring-diamond-svgrepo-com_1_",
    "data-name": "diamond-ring-diamond-svgrepo-com (1)",
    transform: "translate(-119.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8898",
    "data-name": "Trazado 8898",
    className: "cls-1",
    d: "M222.15,0,187.891,74.189H324.109L289.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8899",
    "data-name": "Trazado 8899",
    className: "cls-2",
    d: "M289.85,0h0l34.259,74.189h68.819L348.731,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8900",
    "data-name": "Trazado 8900",
    className: "cls-3",
    d: "M222.15,0H163.269l-44.2,74.189h68.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8901",
    "data-name": "Trazado 8901",
    className: "cls-1",
    d: "M324.109,74.189,256,237.4,392.928,74.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8902",
    "data-name": "Trazado 8902",
    className: "cls-2",
    d: "M187.891,74.189H119.072L256,237.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8903",
    "data-name": "Trazado 8903",
    className: "cls-3",
    d: "M187.891,74.189,256,237.4,324.109,74.189Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamon);
export default __webpack_public_path__ + "static/media/diamon.98c21707a0fc25eb02ecedc47a25ea53.svg";
export { ForwardRef as ReactComponent };